module.exports = __webpack_public_path__ + "img/icon-send.f13a2e92.svg";